import { defineEvent } from "@visioni/a3s-analytics";
import type { AlarmContacts } from "@visioni/a3s-alarm-schedules/schema";
import type { CameraLevel } from "@src/features/alarms/analytics";
import type { RequestErrorType } from "@src/services/api/error-type";

/** Counts are after the save; `action` compares the list size with before. */
export type AlarmContactsChange = {
  action: "added" | "removed" | "updated";
  email_contact_count: number;
  sms_contact_count: number;
};

function contactCount(contacts: AlarmContacts | undefined): number {
  return (contacts?.email_contacts.length ?? 0) + (contacts?.sms_contacts.length ?? 0);
}

export function alarmContactsChange(previous: AlarmContacts | undefined, next: AlarmContacts): AlarmContactsChange {
  const before = contactCount(previous);
  const after = contactCount(next);
  return {
    action:
      after > before ? "added"
      : after < before ? "removed"
      : "updated",
    email_contact_count: next.email_contacts.length,
    sms_contact_count: next.sms_contacts.length,
  };
}

export const AlarmContactsSaved = defineEvent<CameraLevel & AlarmContactsChange>("Alarm Contacts Saved");
export const AlarmContactsFailed = defineEvent<CameraLevel & AlarmContactsChange & { error_type: RequestErrorType }>(
  "Alarm Contacts Failed",
);
